import React from 'react';

import { AuthContext } from 'src/providers/AuthProvider';

export const useAppAuth = () => {
  return React.use(AuthContext);
};
